import React, { Component } from 'react';
import './StatTile.css';

class StatTile extends Component {
	render(){
		return(
			<div className="stat-tile" style={{backgroundColor: this.props.bgColor, color: this.props.textColor}}>
			<p className="stat-tile-stat">{this.props.stat}</p>
			<p className="stat-tile-label">{this.props.label}</p>
			</div>
			)
	}
}

export default StatTile;


// WEBPACK FOOTER //
// ./src/components/CompanyResults/StatsRow/StatTile/StatTile.js